import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { OrderedSet } from 'immutable';
import { useCallback, useMemo } from 'react';
import { getIsReportValidForReportDataLimitDropdown } from './utils';
import { setConfigReportLimit } from 'reporting-data/report/configReportSetters';
import { getConfigReportLimit } from 'reporting-data/report/configReportGetters';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const STANDARD_LIMIT_VALUES = OrderedSet([5, 10, 25, 50]);
const getLimitOptions = value => {
  // if the limit is not a standard value, this makes sure it renders properly
  // by adding an option for it.
  const withNonStandardValue = value ? STANDARD_LIMIT_VALUES.add(value) : STANDARD_LIMIT_VALUES;
  return [{
    value: 'all',
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.report-data-limit-dropdown.config.options.allValues"
    })
  }, ...withNonStandardValue.map(count => ({
    value: count,
    text: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "report-customization-components.customization-components.report-data-limit-dropdown.config.options.otherDataLimit",
      options: {
        count: /*#__PURE__*/_jsx(FormattedNumber, {
          value: count
        })
      }
    })
  })).toList().toJS()];
};
const ConfigReportReportDataLimitDropdown = props => {
  const {
    report,
    onChange
  } = props;
  const originalReportLimit = useMemo(() => getConfigReportLimit(report),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const reportLimitValueForUISelect = useMemo(() => {
    return !getConfigReportLimit(report) ? 'all' : getConfigReportLimit(report);
  }, [report]);
  const dropdownOptions = useMemo(() => {
    return getLimitOptions(originalReportLimit);
  }, [originalReportLimit]);
  const onDataLimitChange = useCallback(({
    target: {
      value
    }
  }) => {
    if (value === 'all') {
      onChange(report.removeIn(['config', 'limit']));
    }
    onChange(setConfigReportLimit(report, Number(value)));
  }, [report, onChange]);
  if (!getIsReportValidForReportDataLimitDropdown({
    report
  })) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.report-data-limit-dropdown.config.displayAmountLabel"
    }),
    children: /*#__PURE__*/_jsx(Select, Object.assign({}, props, {
      "data-test-id": "config-report-data-limit-dropdown",
      value: reportLimitValueForUISelect,
      options: dropdownOptions,
      onChange: onDataLimitChange
    }))
  });
};
export default ConfigReportReportDataLimitDropdown;